
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/ebd2fecf-4a85-47dc-b640-9fbabbbec131.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('ebd2fecf-4a85-47dc-b640-9fbabbbec131');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      